import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2" }
const _hoisted_2 = {
  key: 0,
  class: "w-4 h-4 text-yellow-500 animate-spin shrink-0",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_3 = { class: "text-sm font-semibold text-gray-800" }
const _hoisted_4 = { class: "flex items-center gap-1" }
const _hoisted_5 = {
  key: 0,
  class: "rounded-b-xl overflow-hidden flex flex-col max-h-80"
}
const _hoisted_6 = { class: "sticky top-0 bg-white z-10 px-4 pt-3 pb-2 border-b border-gray-100" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2"
}
const _hoisted_8 = { class: "flex flex-col gap-1" }
const _hoisted_9 = { class: "flex justify-between text-xs text-gray-500" }
const _hoisted_10 = { class: "w-full bg-gray-100 h-1.5 rounded-full overflow-hidden" }
const _hoisted_11 = { class: "flex items-center justify-between mt-0.5" }
const _hoisted_12 = { class: "text-xs text-gray-400" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "overflow-y-auto px-4 py-3" }
const _hoisted_15 = { class: "space-y-3" }
const _hoisted_16 = { class: "flex-1 min-w-0" }
const _hoisted_17 = { class: "text-sm font-medium text-gray-900 truncate" }
const _hoisted_18 = {
  key: 0,
  class: "flex flex-col gap-1 text-xs"
}
const _hoisted_19 = { class: "flex items-center gap-2" }
const _hoisted_20 = { class: "text-yellow-600 font-medium" }
const _hoisted_21 = { class: "text-gray-400" }
const _hoisted_22 = { class: "w-full bg-gray-100 h-1 rounded-full overflow-hidden" }
const _hoisted_23 = {
  key: 1,
  class: "text-xs text-gray-400"
}
const _hoisted_24 = {
  key: 2,
  class: "text-xs text-green-600 font-medium"
}
const _hoisted_25 = ["title"]
const _hoisted_26 = { class: "shrink-0 flex items-center" }
const _hoisted_27 = {
  key: 0,
  class: "w-4 h-4 border-2 border-gray-200 border-t-yellow-500 rounded-full animate-spin"
}
const _hoisted_28 = ["onClick", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_MinusIcon = _resolveComponent("MinusIcon")!
  const _component_ChevronUpIcon = _resolveComponent("ChevronUpIcon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_ArrowPathIcon = _resolveComponent("ArrowPathIcon")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_ExclamationCircleIcon = _resolveComponent("ExclamationCircleIcon")!
  const _component_PhotoIcon = _resolveComponent("PhotoIcon")!

  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "transition-all duration-300",
    "enter-from-class": "opacity-0 translate-y-4",
    "enter-to-class": "opacity-100 translate-y-0",
    "leave-active-class": "transition-all duration-300",
    "leave-from-class": "opacity-100 translate-y-0",
    "leave-to-class": "opacity-0 translate-y-4"
  }, {
    default: _withCtx(() => [
      (_ctx.sessions.length > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["fixed bottom-6 right-6 z-[600] w-96 bg-white border border-gray-200 shadow-xl", _ctx.isCollapsed ? 'rounded-xl' : 'rounded-xl'])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["px-4 py-3 flex items-center justify-between border-b border-gray-200", _ctx.isCollapsed ? 'rounded-xl border-b-0' : 'rounded-t-xl'])
            }, [
              _createElementVNode("div", _hoisted_1, [
                (_ctx.isUploading)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[2] || (_cache[2] = [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }, null, -1),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                      }, null, -1)
                    ])))
                  : (_openBlock(), _createBlock(_component_CheckCircleIcon, {
                      key: 1,
                      class: "w-4 h-4 text-green-500 shrink-0"
                    })),
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.headerTitle), 1)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.isCollapsed = !_ctx.isCollapsed), ["prevent"])),
                  type: "button",
                  class: "p-1 rounded text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors cursor-pointer"
                }, [
                  (!_ctx.isCollapsed)
                    ? (_openBlock(), _createBlock(_component_MinusIcon, {
                        key: 0,
                        class: "w-4 h-4"
                      }))
                    : (_openBlock(), _createBlock(_component_ChevronUpIcon, {
                        key: 1,
                        class: "w-4 h-4"
                      }))
                ]),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dismissAll && _ctx.dismissAll(...args)), ["prevent"])),
                  type: "button",
                  class: "p-1 rounded text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors cursor-pointer"
                }, [
                  _createVNode(_component_XMarkIcon, { class: "w-4 h-4" })
                ])
              ])
            ], 2),
            (!_ctx.isCollapsed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sessions, (session, si) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: session.id,
                      class: _normalizeClass(["flex flex-col min-h-0", { 'border-t border-gray-100': si > 0 }])
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        (_ctx.sessions.length > 1)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(session.galleryName), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('upload_progress.total_progress')), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.sessionPercent(session)) + "%", 1)
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["h-full rounded-full transition-all duration-500", session.isComplete && !_ctx.hasErrors(session) ? 'bg-green-500' : _ctx.hasErrors(session) ? 'bg-red-400' : 'bg-yellow-500']),
                              style: _normalizeStyle({ width: `${_ctx.sessionPercent(session)}%` })
                            }, null, 6)
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("p", _hoisted_12, _toDisplayString(session.uploadedCount) + " " + _toDisplayString(_ctx.$t('upload_progress.of')) + " " + _toDisplayString(session.totalFiles) + " " + _toDisplayString(_ctx.$t('upload_progress.files')), 1),
                            (_ctx.hasErrors(session))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: _withModifiers(($event: any) => (_ctx.retryAllErrors(session)), ["prevent"]),
                                  type: "button",
                                  class: "text-xs text-yellow-600 hover:text-yellow-700 font-medium cursor-pointer flex items-center gap-1"
                                }, [
                                  _createVNode(_component_ArrowPathIcon, { class: "w-3 h-3" }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('upload_progress.retry_all')), 1)
                                ], 8, _hoisted_13))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(session.files, (file) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: file.id,
                              class: _normalizeClass(["flex items-center gap-3", { 'opacity-50': file.status === 'queued' }])
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-8 h-8 rounded flex items-center justify-center shrink-0", {
                                    'bg-gray-100': file.status === 'queued' || file.status === 'uploading',
                                    'bg-green-50': file.status === 'done',
                                    'bg-red-50': file.status === 'error',
                                }])
                              }, [
                                (file.status === 'done')
                                  ? (_openBlock(), _createBlock(_component_CheckIcon, {
                                      key: 0,
                                      class: "w-4 h-4 text-green-600"
                                    }))
                                  : (file.status === 'error')
                                    ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                                        key: 1,
                                        class: "w-4 h-4 text-red-500"
                                      }))
                                    : (_openBlock(), _createBlock(_component_PhotoIcon, {
                                        key: 2,
                                        class: "w-4 h-4 text-gray-400"
                                      }))
                              ], 2),
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("p", _hoisted_17, _toDisplayString(file.name), 1),
                                (file.status === 'uploading')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                      _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('upload_progress.uploading_file')), 1),
                                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.bytesToSize(file.uploadedSize)) + " / " + _toDisplayString(_ctx.bytesToSize(file.size)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_22, [
                                        _createElementVNode("div", {
                                          class: "h-full bg-yellow-500 rounded-full transition-all duration-200",
                                          style: _normalizeStyle({ width: `${_ctx.filePercent(file)}%` })
                                        }, null, 4)
                                      ])
                                    ]))
                                  : (file.status === 'queued')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.$t('upload_progress.queued')), 1))
                                    : (file.status === 'done')
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.$t('upload_progress.file_done')), 1))
                                      : (file.status === 'error')
                                        ? (_openBlock(), _createElementBlock("p", {
                                            key: 3,
                                            class: "text-xs text-red-500 truncate",
                                            title: file.errorMessage
                                          }, _toDisplayString(file.errorMessage || _ctx.$t('upload_progress.file_error')), 9, _hoisted_25))
                                        : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_26, [
                                (file.status === 'uploading')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27))
                                  : (file.status === 'done')
                                    ? (_openBlock(), _createBlock(_component_CheckIcon, {
                                        key: 1,
                                        class: "w-4 h-4 text-green-500"
                                      }))
                                    : (file.status === 'error')
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 2,
                                          onClick: _withModifiers(($event: any) => (_ctx.retryFile(session, file.id)), ["prevent"]),
                                          type: "button",
                                          class: "p-1 rounded text-red-400 hover:text-red-600 hover:bg-red-50 transition-colors cursor-pointer",
                                          title: _ctx.$t('upload_progress.retry')
                                        }, [
                                          _createVNode(_component_ArrowPathIcon, { class: "w-4 h-4" })
                                        ], 8, _hoisted_28))
                                      : _createCommentVNode("", true)
                              ])
                            ], 2))
                          }), 128))
                        ])
                      ])
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}